import Toggle from '@passkeys/ui/toggle';

import exodus from '@/ui/exodus';
import useTestnetsEnabled from '@/ui/hooks/use-testnets-enabled';
import Item from './item.js';

function DeveloperMode() {
  const testnetsEnabled = useTestnetsEnabled();

  const toggleTestnets = async () => {
    await exodus.testnets.toggle();

    exodus.analytics.track({
      event: 'SettingsEnableTestnetsToggle',
      properties: {
        toggledOn: !testnetsEnabled,
      },
    });
  };

  return (
    <Item
      icon="window-terminal"
      label="Developer mode"
      description="Enable testnets for application development."
      dataTestId="developer-mode-settings-item"
      onClick={toggleTestnets}
    >
      <Toggle defaultChecked={testnetsEnabled} />
    </Item>
  );
}

export default DeveloperMode;
